import AbortService from "@rmp/core/services/abortService";
import BaseAuthController from "@rmp/id/api/base/baseAuthController";
import { ApiLoginPayload, ApiSignInWithProfilePayload, FullRequestParams } from "@rmp/api-id";
import { getCaptchaRequestParams, withCaptcha } from "@rmp/core/services/captcha";

export class AuthAppController extends BaseAuthController {
	constructor(private readonly abortService: AbortService) {
		super(abortService);
	}
	
	forgotPassword = withCaptcha(this.api.auth.forgotPasswordCreate, () => this.abortService.getSignal());
	login = (payload: ApiLoginPayload, captchaToken: string) => this.api.auth.loginCreate(payload, {
		...this.getAuthorizationParams(),
		...getCaptchaRequestParams(captchaToken)
	});
	resetPassword = this.api.auth.resetPasswordCreateByUserId;
	signInWithProfile = (payload: ApiSignInWithProfilePayload) => this.api.connect.signInWithProfileCreate(payload, this.getAuthorizationParams());

	authorize = (url: string) => this.api.request<{ redirectUri: string }>({
		path: url,
		method: "GET",
		format: "json",
		withCredentials: true
	});

	private getAuthorizationParams(): Pick<FullRequestParams, "query" | "paramsSerializer"> {
		return {
			query: new URLSearchParams(window.location.search),
			// Сохраняем OAuth-параметры, включая повторяющиеся ключи и закодированные значения.
			paramsSerializer: params => params.toString()
		};
	}
}
